/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["clr-dg-cell.dashboard-tests.datagrid-cell{padding:.25rem .6rem}"];
export { styles as styles };

